<!-- <ng-container *ngIf="quotationDetailsLoader">
  <span
    class="spinner-border spinner-border-sm"
    role="status"
    aria-hidden="true"></span>
</ng-container> -->
<ng-container>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-md-10">
          <div
            class="d-flex align-items-center"
            *ngIf="invoiceDetails?.invoiceNumber">
            <i
              (click)="goBack()"
              class="fa fa-arrow-left mr-2 pointer"
              aria-hidden="true"></i>
            <h1>Edit Invoice -{{ invoiceDetails?.invoiceNumber }}</h1>
          </div>
        </div>

        <!-- <div *ngIf="editMode" class="col-md-2">
            <button
              [disabled]="quotationDetails.locked || contractList.length > 0"
              (click)="openDialog(id)"
              type="button"
              class="btn btn-primary float-right">
              <i class="fa fa-plus" aria-hidden="true"></i> Contract
            </button>
          </div>-->
      </div>
    </div>
  </section>

  <section class="content">
    <div class="card-body table-responsive p-0">
      <div class="table-spinner" *ngIf="quotationDetailsLoader">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-primary">
            <div class="card-header">
              <div class="card-title">Edit Invoice</div>
              <!-- <div
                  *ngIf="viewMode && editMode && !quotationDetails?.locked"
                  class="card-tools">
                  <i
                    tabindex="0"
                    (keyup.enter)="onEditModePress()"
                    (click)="onEditModePress()"
                    class="fas fa-edit"></i>
                </div> -->
            </div>
            <form [formGroup]="quotationForm" (ngSubmit)="onSubmit()">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-11">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="serviceDate">Service Date </label>
                          <input
                            [owlDateTime]="dt4"
                            [max]="maxDate"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('serviceDate')
                                  ?.hasError('required') &&
                                quotationForm.get('serviceDate')?.touched
                            }"
                            [owlDateTimeTrigger]="dt4"
                            class="form-control"
                            formControlName="serviceDate"
                            placeholder="Enter date" />
                          <owl-date-time
                            [pickerType]="'calendar'"
                            #dt4></owl-date-time>
                          <span class="error invalid-feedback"
                            >Please select a date</span
                          >
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="quoteDate">Quotation Date </label>
                          <input
                            [owlDateTime]="dt1"
                            [max]="maxDate"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('quoteDate')
                                  ?.hasError('required') &&
                                quotationForm.get('quoteDate')?.touched
                            }"
                            [owlDateTimeTrigger]="dt1"
                            class="form-control"
                            formControlName="quoteDate"
                            placeholder="Enter date" />
                          <owl-date-time
                            [pickerType]="'calendar'"
                            #dt1></owl-date-time>
                          <span class="error invalid-feedback"
                            >Please select a date</span
                          >
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="clientId">Client </label>
                          <ng-select
                            id="clientId"
                            (clear)="clearSearchClients()"
                            (input)="onInput($event)"
                            (blur)="onFocus(false, 'clientId')"
                            (focus)="onFocus(true, 'clientId')"
                            [searchFn]="customSearchFn"
                            name="clientId"
                            [closeOnSelect]="true"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('clientId')
                                  ?.hasError('required') &&
                                quotationForm.get('clientId')?.touched
                            }"
                            formControlName="clientId"
                            [items]="clientOptions"
                            [multiple]="false"
                            [searchable]="true"
                            [closeOnSelect]="true"
                            [bindLabel]="'name'"
                            [searchable]="true"
                            placeholder="Select Client">
                            <ng-template ng-label-tmp let-item="item">
                              <div>
                                <ng-container *ngIf="item.id">
                                  <span class="rectangle-tag bg-info mr-2">{{
                                    item.id
                                  }}</span>
                                </ng-container>
                                <ng-container *ngIf="item.name">
                                  <span class="rectangle-tag bg-success">{{
                                    item.name
                                  }}</span>
                                </ng-container>
                              </div>
                            </ng-template>

                            <ng-template
                              ng-option-tmp
                              let-item="item"
                              let-index="index">
                              <div>
                                <ng-container *ngIf="item?.id">
                                  <span class="rectangle-tag bg-info mr-2">{{
                                    item.id
                                  }}</span>
                                </ng-container>
                                <ng-container *ngIf="item?.name">
                                  <span class="rectangle-tag bg-success">{{
                                    item.name
                                  }}</span>
                                </ng-container>
                              </div>
                            </ng-template>
                          </ng-select>
                          <span class="error invalid-feedback"
                            >Please select a client</span
                          >
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="currencyId"
                            >Currency <span class="optional-text"> </span
                          ></label>
                          <ng-select
                            (clear)="clearSearchCurrency()"
                            (input)="onInputCurrency($event)"
                            (blur)="onFocus(false, 'currencyId')"
                            (focus)="onFocus(true, 'currencyId')"
                            id="currencyId"
                            name="currencyId"
                            [searchFn]="customSearchFnCurrency"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('currencyId')
                                  ?.hasError('required') &&
                                quotationForm.get('currencyId')?.touched
                            }"
                            formControlName="currencyId"
                            [items]="currencyOptions"
                            [multiple]="false"
                            [closeOnSelect]="true"
                            [bindLabel]="'name'"
                            [searchable]="true"
                            placeholder="Select Currency">
                            <ng-template ng-label-tmp let-item="item">
                              <div>
                                <span class="rectangle-tag bg-success mr-2"
                                  >{{ item.code }}
                                </span>
                                <span class="rectangle-tag bg-info mr-2">{{
                                  item.name
                                }}</span>
                              </div>
                            </ng-template>
                            <ng-template
                              ng-option-tmp
                              let-item="item"
                              let-index="index">
                              <div>
                                <span class="rectangle-tag bg-success mr-2"
                                  >{{ item?.code }}
                                </span>
                                <span class="rectangle-tag bg-info">{{
                                  item?.name
                                }}</span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <span class="error invalid-feedback"
                            >Please select a currency</span
                          >
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="vatId"
                            >VAT <span class="optional-text"></span
                          ></label>
                          <ng-select
                            id="vatId"
                            name="vatId"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('vatId')
                                  ?.hasError('required') &&
                                quotationForm.get('vatId')?.touched
                            }"
                            formControlName="vatId"
                            [items]="vatOptions"
                            [multiple]="false"
                            [closeOnSelect]="true"
                            [bindLabel]="'percentage'"
                            [searchable]="true"
                            placeholder="Select VAT">
                          </ng-select>
                          <span class="error invalid-feedback"
                            >Please select a vat</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Dynamic "legs" entries -->
                  <div class="col-md-12" formArrayName="flightLegs">
                    <div
                      *ngFor="let leg of flightLegs.controls; let i = index"
                      [formGroupName]="i">
                      <div class="border p-3 mb-3">
                        <div class="row">
                          <div class="col-md-11">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="form-group">
                                  <label for="fromAirport"
                                    >From Airport
                                    <span class="optional-text"></span
                                  ></label>
                                  <ng-select
                                    (clear)="clearSearchAirport()"
                                    (input)="onInputAirport($event)"
                                    [searchFn]="customSearchFnAirport"
                                    (blur)="onFocus(false, 'fromAirport')"
                                    (focus)="onFocus(true, 'fromAirport')"
                                    id="fromAirport"
                                    name="fromAirport"
                                    [ngClass]="{
                                      'is-invalid':
                                        leg
                                          .get('fromAirport')
                                          ?.hasError('required') &&
                                        leg.get('fromAirport')?.touched
                                    }"
                                    formControlName="fromAirport"
                                    [items]="airportOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'name'"
                                    [searchable]="true"
                                    placeholder="Select From Airport">
                                    <ng-template ng-label-tmp let-item="item">
                                      <div>
                                        <span
                                          class="rectangle-tag bg-secondary mr-2"
                                          >{{ item.icao }}
                                        </span>
                                        <span class="rectangle-tag bg-success"
                                          >{{ item.city | slice: 0 : 15 }}
                                        </span>

                                        <span
                                          class="rectangle-tag bg-info mr-2"
                                          >{{ item.name | slice: 0 : 15 }}</span
                                        >
                                      </div>
                                    </ng-template>
                                    <ng-template
                                      ng-option-tmp
                                      let-item="item"
                                      let-index="index">
                                      <div>
                                        <span
                                          class="rectangle-tag bg-secondary mr-2"
                                          >{{ item?.icao }}
                                        </span>
                                        <span
                                          class="rectangle-tag bg-success mr-2"
                                          >{{ item?.city | slice: 0 : 15 }}
                                        </span>
                                        <span class="rectangle-tag bg-info">{{
                                          item?.name | slice: 0 : 15
                                        }}</span>
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                  <span class="error invalid-feedback"
                                    >Please select an airport</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="toAirport">
                                      Departure Date
                                      <span class="optional-text"></span
                                    ></label>
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <ng-select
                                          id="timeZoneDeparture"
                                          name="timeZoneDeparture"
                                          [clearable]="false"
                                          [ngClass]="{
                                            'is-invalid':
                                              leg
                                                .get('timeZoneDeparture')
                                                ?.hasError('required') &&
                                              leg.get('timeZoneDeparture')
                                                ?.touched
                                          }"
                                          formControlName="timeZoneDeparture"
                                          (change)="
                                            onChangeDepartureZone($event, i)
                                          "
                                          [items]="timeZoneOptions"
                                          [bindLabel]="'name'"
                                          placeholder="Zone ">
                                        </ng-select>
                                      </div>
                                      <input
                                        [owlDateTime]="dt1"
                                        [ngClass]="{
                                          'is-invalid':
                                            leg
                                              .get('departureDateTime')
                                              ?.hasError('required') &&
                                            leg.get('departureDateTime')
                                              ?.touched
                                        }"
                                        [owlDateTimeTrigger]="dt1"
                                        class="form-control"
                                        formControlName="departureDateTime"
                                        (ngModelChange)="
                                          onDepartureDateTimeSelected(
                                            $event,
                                            i,
                                            leg.get('flightTime')?.value
                                          )
                                        "
                                        placeholder="Select date and time" />
                                      <div class="input-group-append">
                                        <owl-date-time
                                          [scrollStrategy]="
                                            scrollStrategiesDt1[i]
                                          "
                                          #dt1></owl-date-time>
                                      </div>
                                      <span class="error invalid-feedback"
                                        >Please select a date and time</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="form-group">
                                  <label for="aircraft">Aircraft </label>
                                  <ng-select
                                    id="aircraft"
                                    (clear)="clearSearchAircraft()"
                                    (input)="onInputAircraft($event)"
                                    (blur)="onFocus(false, 'aircraft')"
                                    [searchFn]="customSearchFnAirCraft"
                                    name="aircraft"
                                    [ngClass]="{
                                      'is-invalid':
                                        leg
                                          .get('aircraft')
                                          ?.hasError('required') &&
                                        leg.get('aircraft')?.touched
                                    }"
                                    formControlName="aircraft"
                                    [items]="aircraftOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'tailName'"
                                    [searchable]="true"
                                    placeholder="Select Aircraft ">
                                  </ng-select>
                                  <span class="error invalid-feedback"
                                    >Please select an aircraft</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="form-group">
                                  <label for="toAirport"
                                    >To Airport
                                    <span class="optional-text"></span
                                  ></label>
                                  <ng-select
                                    id="toAirport"
                                    name="toAirport"
                                    (clear)="clearSearchAirport()"
                                    (input)="onInputAirport($event)"
                                    (blur)="onFocus(false, 'toAirport')"
                                    (focus)="onFocus(true, 'toAirport')"
                                    [searchFn]="customSearchFnAirport"
                                    [ngClass]="{
                                      'is-invalid':
                                        leg
                                          .get('toAirport')
                                          ?.hasError('required') &&
                                        leg.get('toAirport')?.touched
                                    }"
                                    formControlName="toAirport"
                                    [items]="airportOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'name'"
                                    [searchable]="true"
                                    placeholder="Select To Airport">
                                    <ng-template ng-label-tmp let-item="item">
                                      <div>
                                        <span
                                          class="rectangle-tag bg-secondary mr-2"
                                          >{{ item.icao }}
                                        </span>
                                        <span class="rectangle-tag bg-success"
                                          >{{ item.city | slice: 0 : 15 }}
                                        </span>
                                        <span
                                          class="rectangle-tag bg-info mr-2"
                                          >{{ item.name | slice: 0 : 15 }}</span
                                        >
                                      </div>
                                    </ng-template>
                                    <ng-template
                                      ng-option-tmp
                                      let-item="item"
                                      let-index="index">
                                      <div>
                                        <span
                                          class="rectangle-tag bg-secondary mr-2"
                                          >{{ item?.icao }}
                                        </span>
                                        <span
                                          class="rectangle-tag bg-success mr-2"
                                          >{{ item?.city | slice: 0 : 15 }}
                                        </span>
                                        <span class="rectangle-tag bg-info">{{
                                          item?.name | slice: 0 : 15
                                        }}</span>
                                      </div>
                                    </ng-template>
                                  </ng-select>
                                  <span class="error invalid-feedback"
                                    >Please select an airport</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-12">
                                    <label for="toAirport">
                                      Arrival Date
                                    </label>
                                    <label for="timeZoneArrival"
                                      >{{ null }}
                                    </label>
                                    <div class="input-group">
                                      <div class="input-group-prepend">
                                        <ng-select
                                          id="timeZoneArrival"
                                          (clear)="clearSearchAircraft()"
                                          (input)="onInputAircraft($event)"
                                          [searchFn]="customSearchFnAirCraft"
                                          name="timeZoneArrival"
                                          [ngClass]="{
                                            'is-invalid':
                                              leg
                                                .get('timeZoneArrival')
                                                ?.hasError('required') &&
                                              leg.get('timeZoneArrival')
                                                ?.touched
                                          }"
                                          formControlName="timeZoneArrival"
                                          (change)="
                                            onChangeArrivalZone($event, i)
                                          "
                                          [items]="timeZoneOptions"
                                          [multiple]="false"
                                          [clearable]="false"
                                          [bindLabel]="'name'"
                                          placeholder="Zone ">
                                        </ng-select>
                                      </div>
                                      <input
                                        [owlDateTime]="dt2"
                                        [ngClass]="{
                                          'is-invalid':
                                            (leg
                                              .get('arrivalDateTime')
                                              ?.hasError('required') &&
                                              leg.get('arrivalDateTime')
                                                ?.touched) ||
                                            leg.errors?.[
                                              'arrivalAfterDeparture'
                                            ]
                                        }"
                                        [owlDateTimeTrigger]="dt2"
                                        class="form-control"
                                        formControlName="arrivalDateTime"
                                        placeholder="Select date and time" />
                                      <div class="input-group-append">
                                        <owl-date-time
                                          [scrollStrategy]="
                                            scrollStrategiesDt2[i]
                                          "
                                          #dt2></owl-date-time>
                                      </div>
                                      <span
                                        class="error invalid-feedback"
                                        *ngIf="
                                          leg
                                            .get('arrivalDateTime')
                                            ?.hasError('required') &&
                                          leg.get('arrivalDateTime')?.touched
                                        ">
                                        Please select a date and time
                                      </span>

                                      <span
                                        class="error invalid-feedback"
                                        *ngIf="
                                          leg.errors?.[
                                            'arrivalAfterDeparture'
                                          ] &&
                                          leg.get('arrivalDateTime')?.touched &&
                                          !leg
                                            .get('arrivalDateTime')
                                            ?.hasError('required')
                                        ">
                                        Arrival must be after Departure
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4">
                                <div class="form-group">
                                  <label for="flightTime">Flight Time </label>

                                  <input
                                    matInput
                                    [matAutocomplete]="autoFlightTime"
                                    class="form-control"
                                    placeholder="hh:mm"
                                    [ngClass]="{
                                      'is-invalid':
                                        (leg
                                          .get('flightTime')
                                          ?.hasError('required') &&
                                          leg.get('flightTime')?.touched) ||
                                        (leg
                                          .get('flightTime')
                                          ?.hasError('pattern') &&
                                          leg.get('flightTime')?.touched)
                                    }"
                                    formControlName="flightTime" />

                                  <mat-autocomplete
                                    #autoFlightTime="matAutocomplete">
                                    <mat-option
                                      *ngFor="let option of flightTimeOptions"
                                      [value]="option">
                                      {{ option }}
                                    </mat-option>
                                  </mat-autocomplete>

                                  <span class="error invalid-feedback"
                                    >Please enter flight time in (hh:mm)
                                    format</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="pax">Passengers (PAX) </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    formControlName="pax"
                                    [ngClass]="{
                                      'is-invalid':
                                        (leg.get('pax')?.hasError('pattern') &&
                                          leg.get('pax')?.touched) ||
                                        (leg.get('pax')?.hasError('required') &&
                                          leg.get('pax')?.touched)
                                    }"
                                    placeholder="Enter  pax count" />
                                  <span class="error invalid-feedback"
                                    >Enter valid pax count
                                  </span>
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="hourlyRate">Hourly Rate </label>
                                  <input
                                    matInput
                                    [matAutocomplete]="autoHourly"
                                    [ngClass]="{
                                      'is-invalid':
                                        (leg
                                          .get('hourlyRate')
                                          ?.hasError('required') &&
                                          leg.get('hourlyRate')?.touched) ||
                                        (leg
                                          .get('hourlyRate')
                                          ?.hasError('pattern') &&
                                          leg.get('hourlyRate')?.touched)
                                    }"
                                    type="text"
                                    class="form-control"
                                    formControlName="hourlyRate"
                                    placeholder="Enter the hourly rate" />

                                  <mat-autocomplete
                                    #autoHourly="matAutocomplete">
                                    <mat-option
                                      *ngFor="let option of hourlyRateOptions"
                                      [value]="option">
                                      {{ option }}
                                    </mat-option>
                                  </mat-autocomplete>
                                  <span class="error invalid-feedback"
                                    >Please enter a valid hourly rate</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="layOverTime">Layover Time </label>

                                  <input
                                    matInput
                                    [matAutocomplete]="autoLayOver"
                                    class="form-control"
                                    placeholder="hh:mm"
                                    [ngClass]="{
                                      'is-invalid':
                                        (leg
                                          .get('layOverTime')
                                          ?.hasError('required') &&
                                          leg.get('layOverTime')?.touched) ||
                                        (leg
                                          .get('layOverTime')
                                          ?.hasError('pattern') &&
                                          leg.get('layOverTime')?.touched)
                                    }"
                                    formControlName="layOverTime" />

                                  <mat-autocomplete
                                    #autoLayOver="matAutocomplete">
                                    <mat-option
                                      *ngFor="let option of layOverTimeOptions"
                                      [value]="option">
                                      {{ option }}
                                    </mat-option>
                                  </mat-autocomplete>

                                  <span class="error invalid-feedback"
                                    >Please enter layover time in (hh:mm)
                                    format</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="vatId"
                                    >VAT <span class="optional-text"></span
                                  ></label>
                                  <ng-select
                                    id="vatId"
                                    name="vatId"
                                    [ngClass]="{
                                      'is-invalid':
                                        leg
                                          .get('vatId')
                                          ?.hasError('required') &&
                                        leg.get('vatId')?.touched
                                    }"
                                    formControlName="vatId"
                                    [items]="vatOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'percentage'"
                                    [searchable]="true"
                                    placeholder="Select VAT">
                                  </ng-select>

                                  <span class="error invalid-feedback"
                                    >Please select a vat</span
                                  >
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="deadHead">Dead Head</label>
                                  <div class="form-check">
                                    <input
                                      type="checkbox"
                                      id="deadHead"
                                      name="deadHead"
                                      formControlName="deadHead"
                                      class="form-check-input" />
                                    <label
                                      class="form-check-label"
                                      for="deadHead"></label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div
                              *ngIf="i > 0"
                              style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              "
                              class="col-md-1">
                              <span
                                (click)="removelegs(i)"
                                (keydown)="removelegs(i)"
                                tabindex="0"
                                class="remove-icon"
                                (click)="removelegs(i)">
                                <i class="fa fa-times delete-icon pointer"></i>
                              </span>
                            </div> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="row"> -->

                  <!-- </div> -->

                  <!-- The button to add more leg entries -->

                  <div class="col-md-12" formArrayName="additionalCharge">
                    <div
                      *ngFor="
                        let charge of additionalCharge?.controls;
                        let i = index
                      "
                      [formGroupName]="i">
                      <div class="border p-3 mb-3">
                        <div class="row">
                          <div class="col-md-11">
                            <div class="row">
                              <div class="col-md-6">
                                <!-- <div [formGroup]="charge"> -->
                                <div class="form-group">
                                  <label for="itemDescription"
                                    >Description
                                  </label>
                                  <textarea
                                    class="form-control"
                                    formControlName="itemDescription"
                                    [ngClass]="{
                                      'is-invalid':
                                        charge
                                          .get('itemDescription')
                                          ?.hasError('required') &&
                                        charge.get('itemDescription')?.touched
                                    }"
                                    placeholder="Enter description"
                                    rows="1"></textarea>
                                  <span class="error invalid-feedback"
                                    >Please enter description</span
                                  >
                                </div>
                                <!-- </div> -->
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="vatId"
                                    >VAT <span class="optional-text"></span
                                  ></label>
                                  <ng-select
                                    id="vatId"
                                    name="vatId"
                                    formControlName="vatId"
                                    [items]="vatOptions"
                                    [ngClass]="{
                                      'is-invalid':
                                        charge
                                          .get('vatId')
                                          ?.hasError('required') &&
                                        charge.get('vatId')?.touched
                                    }"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'percentage'"
                                    [searchable]="true"
                                    placeholder="Select VAT">
                                  </ng-select>

                                  <span class="error invalid-feedback"
                                    >Please select a vat</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-3">
                                <!-- <div [formGroup]="charge"> -->
                                <div class="form-group">
                                  <label for="amount">Amount </label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    [ngClass]="{
                                      'is-invalid':
                                        (charge
                                          .get('amount')
                                          ?.hasError('required') &&
                                          charge.get('amount')?.touched) ||
                                        (charge
                                          .get('amount')
                                          ?.hasError('pattern') &&
                                          charge.get('amount')?.touched)
                                    }"
                                    formControlName="amount"
                                    placeholder="Enter amount" />
                                  <span class="error invalid-feedback"
                                    >Please enter a valid amount</span
                                  >
                                </div>
                                <!-- </div> -->
                              </div>
                            </div>
                          </div>

                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                            class="col-md-1"></div>
                        </div>
                      </div>
                    </div>
                    <!-- The button to add additional charges -->
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-11">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="bankId">Bank </label>
                          <ng-select
                            id="bankId"
                            [searchFn]="bankSearchService.bankCustomSearchFn"
                            name="bankId"
                            [ngClass]="{
                              'is-invalid':
                                quotationForm
                                  .get('bankId')
                                  ?.hasError('required') &&
                                quotationForm.get('bankId')?.touched
                            }"
                            formControlName="bankId"
                            [items]="bankOptions"
                            [multiple]="true"
                            [maxSelectedItems]="2"
                            [closeOnSelect]="true"
                            [bindLabel]="'name'"
                            [searchable]="true"
                            placeholder="Select Bank">
                            <ng-template ng-label-tmp let-item="item">
                              <div>
                                <span class="rectangle-tag bg-info mr-2">{{
                                  item?.ibanNumber
                                }}</span>
                                <span class="rectangle-tag bg-success mr-2"
                                  >{{ item?.name }}
                                </span>
                                <span class="rectangle-tag bg-primary mr-2"
                                  >{{ item?.accountCurrency.code }}
                                </span>
                              </div>
                            </ng-template>
                            <ng-template
                              ng-option-tmp
                              let-item="item"
                              let-index="index">
                              <div>
                                <span class="rectangle-tag bg-info mr-2">{{
                                  item?.ibanNumber
                                }}</span>
                                <span class="rectangle-tag bg-success mr-2"
                                  >{{ item?.name }}
                                </span>
                                <span class="rectangle-tag bg-primary mr-2"
                                  >{{ item?.accountCurrency.code }}
                                </span>
                              </div>
                            </ng-template>
                          </ng-select>
                          <span class="error invalid-feedback"
                            >Please select a bank</span
                          >
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="remarks">Remarks</label>
                          <textarea
                            class="form-control"
                            formControlName="remarks"
                            placeholder="Enter remarks"
                            rows="1"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="card-footer-display">
                  <button
                    class="btn btn-secondary float-right"
                    type="button"
                    (click)="goBack()">
                    Cancel
                  </button>

                  <button
                    type="submit"
                    [disabled]="quotationForm.invalid"
                    class="btn btn-primary float-right custom-button">
                    <ng-container *ngIf="createLoading; else submitText">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                    </ng-container>
                  </button>
                  <ng-template #submitText>Submit</ng-template>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- contract list -->
  <section *ngIf="id && contractList.length > 0" class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <h2>Contracts</h2>
        </div>
      </div>

      <div class="contract-section p-4 rounded border mb-2">
        <div class="row">
          <ng-container *ngFor="let contract of contractList">
            <div class="col-md-4">
              <div class="card card-primary">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ contract.contractNumber }}
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text">
                    <i class="fas fa-calendar-alt"></i> Contract Date:
                    {{
                      dateFormatService.formatDateOnly(
                        contract.date || '',
                        'DD-MMM-yyyy'
                      )
                    }}
                  </p>
                  <p class="card-text">
                    <i class="fas fa-file-alt"></i> Contract Number:
                    {{ contract.contractNumber }}
                  </p>
                </div>
                <div class="card-footer">
                  <button
                    type="button"
                    [disabled]="contract.locked"
                    class="btn btn-primary float-right">
                    Create invoice <i class="fas fa-file-invoice"></i>
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
</ng-container>
